import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactNode } from 'react';

const IconFeather = (props: { icon: ReactNode; muiProps?: SvgIconProps }) => {
  const muiProps = props?.muiProps ?? {};
  return <SvgIcon {...muiProps}>{props.icon}</SvgIcon>;
};

export default IconFeather;
